import React, { useState, useEffect } from 'react';
import './Keyboard.css';

const WIDE_ROW_1 = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
const WIDE_ROW_2 = ['Submit', 'A', 'B', 'C', 'D', 'E', 'F', 'Delete'];

const COMPACT_ROW_1 = ['0', '1', '2', '3', '4', '5', '6'];
const COMPACT_ROW_2 = ['7', '8', '9', 'A', 'B', 'C'];
const COMPACT_ROW_3 = ['Submit', 'D', 'E', 'F', 'Delete'];

const Keyboard = ({ onKeyPress, onDelete, onSubmit, canDelete, canSubmit, keyStates = {} }) => {

  const [isCompact, setIsCompact] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => {
      setIsCompact(window.innerWidth < 600);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderDigitKey = (key) => {
    const state = keyStates[key];
    const isGray = state === 'gray';
    return (
      <button
        key={key}
        className={state ? `key-${state}` : ''}
        onClick={() => onKeyPress(key)}
        disabled={isGray}
      >
        {key}
      </button>
    );
  };

  const renderControlKey = (key) => {
    if (key === 'Submit') {
      return (
        <button key="Submit"
          className={`control-key enter-key ${canSubmit ? 'enabled' : ''}`}
          onClick={onSubmit}>
            SUBMIT
        </button>
      );
    }
    return (
      <button key="Delete"
        className={`control-key delete-key ${canDelete ? 'enabled' : ''}`}
        onClick={onDelete}>
         ⌫
      </button>
    );
  };

  const renderKey = (key) =>
    key === 'Submit' || key === 'Delete' ? renderControlKey(key) : renderDigitKey(key);

  return (
    <div className="keyboard">
      {isCompact ? (
        <>
          <div className="keyboard-row">
            {COMPACT_ROW_1.map(renderKey)}
          </div>
          <div className="keyboard-row">
            {COMPACT_ROW_2.map(renderKey)}
          </div>
          <div className="keyboard-row">
            {COMPACT_ROW_3.map(renderKey)}
          </div>
        </>
      ) : (
        <>
          <div className="keyboard-row">
            {WIDE_ROW_1.map(renderKey)}
          </div>
          <div className="keyboard-row">
            {WIDE_ROW_2.map(renderKey)}
          </div>
        </>
      )}
    </div>
  );
};

export default Keyboard;
